// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"background-image-module--background-image--2n2Ml"};